import { BaseService } from './base'
import { APIPath } from 'utility/constant'

class ShareEmailSubjectFormatServiceClass {
    get() {
        return BaseService.get(APIPath.shareEmailSubjectFormat)
    }

    save(data) {
        return BaseService.post(APIPath.shareEmailSubjectFormat, data)
    }

    preview(data) {
        return BaseService.post(APIPath.shareEmailSubjectFormatPreview, data)
    }
}

const ShareEmailSubjectFormatService = new ShareEmailSubjectFormatServiceClass()
Object.freeze(ShareEmailSubjectFormatService)
export { ShareEmailSubjectFormatService }
